export const SERVICES_QUERY_KEY = 'services'
export const SERVICES_ANONYMOUSLY_QUERY_KEY = 'servicesAnonymously'
export const INTERBRANCH_SERVICES_QUERY_KEY = 'interbranchServices'
export const ALL_SERVICES_QUERY_KEY = 'allServices'
export const SERVICES_BRIEF_QUERY_KEY = 'servicesBrief'
export const SERVICES_BRIEF_FOR_SALE_QUERY_KEY = 'servicesBriefForSale'
export const DEACTIVATED_SERVICES_QUERY_KEY = 'deactivatedServices'
export const SERVICES_WITHOUT_BRANCH_LOCATION = 'servicesWithoutBranchLocation'
